import { useLocation } from "react-router-dom";
import { useEffect } from 'react';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            const rect = element.getBoundingClientRect();
            document.documentElement.scrollTo({
                top: rect.top - 55,
                left: 0,
                behavior: "instant",
            });
        }
        else {
            document.documentElement.scrollTo({
                top: 0,
                left: 0,
                // behavior: "instant", // Optional if you want to skip the scrolling animation
            });
        }

    }, [pathname, hash]);

    return null;
}
